import { createContext } from "react";
import type { IconProps } from "../Icon";
import type { AlertButton, AlertOptions, ViewStyle } from "react-native";

export interface ContextType {
  alert: (
    title: string,
    message?: string,
    buttons?: AlertButton[],
    iconName?: IconProps["name"],
    options?: AlertOptions & { buttonsContainerStyle?: ViewStyle },
  ) => void;
}

export const AlertContext = createContext<ContextType | undefined>(undefined);
